import { render, staticRenderFns } from "./MaterialsStockColorsForm.vue?vue&type=template&id=50a106a3&"
import script from "./MaterialsStockColorsForm.vue?vue&type=script&lang=js&"
export * from "./MaterialsStockColorsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports